<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" @close="close" :close-on-click-modal="false" :close-on-press-escape="false" width="900px">
        <el-form size="small" :model="form" :rules="formRules" :label-width="formLabelWidth" ref="form">

            <el-form-item label="标题" prop="title">
                <el-input v-model="form.title" placeholder="标题" clearable/>
            </el-form-item>
            <el-form-item label="封面" prop="image_id">
                <el-row>
                    <el-button type="primary" @click="openUpload">选择图片</el-button>
                    <div v-if="form.image_id !== ''" class="img">
                        <img :src="file_path" width="100" height="100" />
                    </div>
                </el-row>
            </el-form-item>

            <el-form-item label="投票时间">
                <div class="block">
                    <span class="demonstration"></span>
                    <el-date-picker
                            size="small"
                            v-model="form.vote_time"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                    >
                    </el-date-picker>
                </div>
            </el-form-item>

            <el-form-item label="投票次数" prop="user_max_num">
                <el-input v-model.number="form.user_max_num" autocomplete="off"></el-input>
                <div class="tips">每个微信号每天可以投票次数.</div>
            </el-form-item>

            <el-form-item label="同一选手投票次数" prop="cmpe_max_num">
                <el-input v-model.number="form.cmpe_max_num" autocomplete="off"></el-input>
                <div class="tips">每个微信号每天可为同一选手投票次数.</div>
            </el-form-item>

            <el-form-item label="内容" prop="content">
                <Editor :text="form.content" @get-content="contentChangeFunc" :width="600" ></Editor>
            </el-form-item>

            <el-form-item label="状态">
                <el-radio-group v-model="form.is_show">
                    <el-radio :label="1">显示</el-radio>
                    <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="排序" prop="sort">
                <el-input v-model.number="form.sort" autocomplete="off"></el-input>
                <div class="tips">越小越靠前</div>
            </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="save" :disabled="submit_loading">确 定</el-button>
        </div>
        <!--上传图片组件-->
        <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
    </el-dialog>
</template>

<script>
    import { voteEdit, voteDetail } from '@/api/education';
    import Upload from '@/components/file/Upload';
    import Editor from '@/components/tsk/editor'


    export default {
        components: { Upload, Editor },
        data() {
            return {
                title: '',
                form: {
                    vote_id: '',
                    image_id: '',
                    title: '',
                    content: '',
                    vote_time: [],
                    user_max_num: 1,
                    cmpe_max_num: 1,
                    sort: 1,
                    is_show: 1,
                },
                file_path: '',
                /*左边长度*/
                formLabelWidth: '120px',
                /*是否显示*/
                dialogFormVisible: false,
                /*是否正在提交*/
                submit_loading: false,
                /*链接选择*/
                is_linkset: false,
                // 验证
                formRules: {
                    title: [{
                        required: true,
                        message: '请输入标题',
                        trigger: 'blur'
                    }]
                },
                /*上传图片*/
                isupload: false,

            };
        },
        props: ['fetch-data'],
        created() {

        },
        methods: {
            showDialog(row) {
                if (!row) {
                    this.title = '添加评选'
                } else {
                    this.title = '编辑评选'
                    this.form.vote_id = row.vote_id
                    this.getDetail()
                }
                this.dialogFormVisible = true
            },
            // 关闭
            close() {
                this.$refs['form'].resetFields()
                this.form = this.$options.data().form
                this.form.content = ''
                this.dialogFormVisible = false
            },
            // 保存
            save() {
                this.$refs['form'].validate(async (valid) => {
                    if (valid) {
                        this.submit_loading = true
                        voteEdit(this.form).then((result)=>{
                            this.$message({message: result.msg, type: 'success'});
                            this.$emit('fetch-data')
                            this.submit_loading = false
                            this.close()
                        }).catch(()=>{
                            this.submit_loading = false
                        })
                    }
                })
            },
            getDetail(){
                voteDetail({id: this.form.vote_id}).then((result)=>{
                    this.form = Object.assign({}, result.data)
                    this.file_path = result.data.file_path
                })
            },

            courseTypeChange(val){
                this.form.course_type = val
            },
            contentChangeFunc(val){
                this.form.content = val
            },
            // 图片上传
            openUpload(e) {
                // this.type = e;
                this.isupload = true;
            },
            /*获取图片*/
            returnImgsFunc(e) {
                if (e != null && e.length > 0) {
                    this.file_path = e[0].file_path;
                    this.form.image_id = e[0].file_id;
                }
                this.isupload = false;
            },

        }
    };
</script>

<style scoped>
    .tips {
        color: #ccc;
    }
</style>



// WEBPACK FOOTER //
// src/views/education/vote/vote/edit.vue